var chunkMapping = {
	"16": [
		53016
	],
	"100": [
		90100
	],
	"127": [
		73127
	],
	"160": [
		35160
	],
	"414": [
		81414
	],
	"450": [
		57450
	],
	"495": [
		59495
	],
	"543": [
		23543
	],
	"560": [
		4560
	],
	"701": [
		58701
	],
	"726": [
		31726
	]
};
var idToExternalAndNameMapping = {
	"4560": [
		"default",
		"./Karavan_ui_4_10_2",
		3120
	],
	"23543": [
		"default",
		"./Properties",
		51856
	],
	"31726": [
		"default",
		"./catalogue",
		3440
	],
	"35160": [
		"default",
		"./swaggerApp",
		71898
	],
	"53016": [
		"default",
		"./policyManagement",
		19725
	],
	"57450": [
		"default",
		"./mftRouter",
		85766
	],
	"58701": [
		"default",
		"./list",
		37597
	],
	"59495": [
		"default",
		"./Events",
		28454
	],
	"73127": [
		"default",
		"./integrations",
		96706
	],
	"81414": [
		"default",
		"./workspaceManager",
		62524
	],
	"90100": [
		"default",
		"./home",
		88177
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}